import { SHORTCUT_PAGE_INFO_FIELDS } from '@@partner:graphql/shortcuts'
import { ReportType } from '@@partner:types:app'
import { gql } from '@apollo/client'
import { useLazyQuery, useQuery } from '@apollo/client'

type ReportTypesResponse = {
  allReportTypes: {
    edges: ReportType[]
  }
}

const GET_REPORT_TYPES = gql`
  query GetReportTypes {
    allReportTypes {
      edges {
        id
        key
        name
        description
        created_at
        updated_at
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

const GET_REPORT_SCHEDULES = gql`
  query GetReportSchedules($filter: NestedFilterInput, $sort: CommonSortInput, $pager: CommonPagerInput) {
    allReportSchedules(filter: $filter, sort: $sort, pager: $pager) {
      edges {
        id
        report_type_id
        shops {
          id
          name
          address
        }
        name
        description
        frequency
        recipients
        subject
        options
        is_enabled
        last_run_at
        next_run_at
        created_at
        updated_at
        reportType {
          id
          key
          name
          description
        }
      }
      pageInfo {
        ${SHORTCUT_PAGE_INFO_FIELDS}
      }
    }
  }
`

export const useFetchReportTypes = () => useQuery<ReportTypesResponse>(GET_REPORT_TYPES)

export const useLazyFetchReportSchedules = () => useLazyQuery(GET_REPORT_SCHEDULES)

export const useFetchReportSchedules = (variables?: any) => 
  useQuery(GET_REPORT_SCHEDULES, { variables })
